<template>
    <div>
        <form class="basic-form">
            <div class="form-group">
                <label :for="fieldId" class="hidden">Email address</label>
                <input v-model="form.subscribe_email"
                       type="email"
                       class="form-control"
                       :id="fieldId"
                       :class="{'is-invalid': errors.has('subscribe_email')}"
                       v-validate="'required|max:50|email'"
                       placeholder="Enter your email address"
                       :disabled="loading"
                       data-vv-as="Email">
                <span class="validation-errors"
                      v-for="error in errors.collect('subscribe_email')">{{ error }}</span>
            </div>
            <button class="btn btn-primary" type="submit" @click.prevent="sendForm" v-loading="loading">Join now
            </button>
        </form>

        <el-dialog
                :title="confirmationTitle"
                :visible.sync="dialogVisible"
                :lock-scroll="false"
                :append-to-body="true"
                width="30%">
            <span>{{ confirmationBody }}</span>
            <div slot="footer" class="dialog-footer">
                <button class="btn btn-default" @click="dialogVisible = false">Close</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "SubscribeForm",
        props: {
            action: {
                required: true,
                type: String,
            },
            confirmationTitle: {
                type: String,
                default: "You’re all set!",
            },
            confirmationBody: {
                type: String,
                default: "Thank you for subscribing."
            }
        },
        data: () => ({
            loading: false,
            dialogVisible: false,
            fieldId: '',
            form: {
                subscribe_email: '',
            }
        }),
        mounted() {
          this.fieldId = this._uid + '_email'
        },
        computed: {
            isReCaptchaReady() {
                return !!(window.reCaptchaKey && typeof window.grecaptcha !== 'undefined');
            },
        },
        methods: {
            sendForm() {
                this.$validator
                    .validate()
                    .then(valid => {
                        if (!valid) {
                            return false;
                        }

                        this.loading = true;

                        let {form} = this;

                        if (this.isReCaptchaReady) {
                            window.grecaptcha.ready(() => {
                                window.grecaptcha.execute(window.reCaptchaKey, {action: 'contact_form'})
                                    .then((token) => {
                                        form['g-recaptcha-response'] = token;
                                        this.sendFormData(form);
                                    });
                            });
                        } else {
                            this.sendFormData(form);
                        }
                    });
            },
            sendFormData(form) {
                axios.post(this.action, form)
                    .then(() => {
                        this.dialogVisible = true;
                        this.form.subscribe_email = '';
                        this.$nextTick(() => this.$validator.reset());
                    })
                    .catch(e => {
                        this.$handleError(e);
                    })
                    .finally(() => {
                        this.loading = false;

                        setTimeout(() => this.dialogVisible = false, 5000);
                    })
            }
        }
    }
</script>
